import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKategorSeciDetaySatinAlma_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKategorSeciDetaySatinAlma_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetInvoicePurchaseBrandCharSelectCategory: any[];
  GetInvoicePurchaseBrandCharSelectCategory_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp428423Visible: "visible" | "hidden";
  isComp839481Visible: "visible" | "hidden";
}

export class KategorSeciDetaySatinAlma_ScreenBase extends React.PureComponent<
  IKategorSeciDetaySatinAlma_ScreenProps,
  any
> {
  kategorsecidetaysatinalma_265841_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "c97f605c-2640-42f6-9429-438ddcbbccf6",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 375301, PropertyName: "value", Value: "Kategori Seç" },
        { Id: 701175, PropertyName: "value", Value: "Tedarikçi Adı" },
        { Id: 717934, PropertyName: "value", Value: "21.02.2025" },
        { Id: 177915, PropertyName: "value", Value: "-" },
        { Id: 716883, PropertyName: "value", Value: "21.02.2025" },
        { Id: 24250, PropertyName: "value", Value: "Marka Adı" },
        { Id: 298341, PropertyName: "value", Value: "Toplam Adet" },
        { Id: 640527, PropertyName: "value", Value: "Toplam Fiyat" },
        { Id: 473499, PropertyName: "placeholder", Value: "Kategori Adı..." },
        { Id: 848805, PropertyName: "label", Value: "Ara" },
        { Id: 205234, PropertyName: "label", Value: "Temizle" },
        { Id: 707378, PropertyName: "title", Value: "Title" },
        {
          Id: 565975,
          PropertyName: "value",
          Value: "[datafield:productatt01desc]",
        },
        { Id: 492478, PropertyName: "value", Value: "Miktar" },
        { Id: 576788, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 76680, PropertyName: "value", Value: "Tutar" },
        { Id: 254454, PropertyName: "value", Value: "[datafield:tutar]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.kategorsecidetaysatinalma_473499_value_kuikaTextInputRef =
      React.createRef();
    this.kategorsecidetaysatinalma_265841_value_kuikaTableRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetInvoicePurchaseBrandCharSelectCategory: [],
      SetValueOf: "",
      NAVIGATE: "",
      isComp428423Visible: "hidden",
      isComp839481Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "kategorsecidetaysatinalma",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KategorSeciDetaySatinAlmaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kategorsecidetaysatinalma", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kategorsecidetaysatinalma", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KategorSeciDetaySatinAlmaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KategorSeciDetaySatinAlmaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      ),
      productAtt02Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BrandName ?? this.props.screenInputs.brandname,
        "string"
      ),
      designName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KategorSeciDetaySatinAlma/KategorSeciDetaySatinAlmaPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseBrandCharSelectCategory =
      result?.data.getInvoicePurchaseBrandCharSelectCategory;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KategorSeciDetaySatinAlmaPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KategorSeciDetaySatinAlmaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseBrandCharSelectCategory ??
      this.state.GetInvoicePurchaseBrandCharSelectCategory;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KategorSeciDetaySatinAlmaComponent_711085_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KategorSeciDetaySatinAlmaComponent_848805_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      ),
      productAtt02Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BrandName ?? this.props.screenInputs.brandname,
        "string"
      ),
      designName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kategorsecidetaysatinalma_473499_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KategorSeciDetaySatinAlma/KategorSeciDetaySatinAlmaComponent_848805_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseBrandCharSelectCategory =
      result?.data.getInvoicePurchaseBrandCharSelectCategory;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KategorSeciDetaySatinAlmaComponent_848805_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KategorSeciDetaySatinAlmaComponent_848805_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseBrandCharSelectCategory ??
      this.state.GetInvoicePurchaseBrandCharSelectCategory;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KategorSeciDetaySatinAlmaComponent_205234_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      ),
      productAtt02Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BrandName ?? this.props.screenInputs.brandname,
        "string"
      ),
      designName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KategorSeciDetaySatinAlma/KategorSeciDetaySatinAlmaComponent_205234_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseBrandCharSelectCategory =
      result?.data.getInvoicePurchaseBrandCharSelectCategory;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KategorSeciDetaySatinAlmaComponent_205234_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KategorSeciDetaySatinAlmaComponent_205234_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kategorsecidetaysatinalma_473499_value",
        "string"
      ),
      "",
      null,
      false
    );

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseBrandCharSelectCategory ??
      this.state.GetInvoicePurchaseBrandCharSelectCategory;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KategorSeciDetaySatinAlmaComponent_839481_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "UrunSecDetaySatinAlma",
      "VendorName",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorName ??
          this.props.screenInputs.vendorname,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UrunSecDetaySatinAlma",
      "BrandName",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BrandName ?? this.props.screenInputs.brandname,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UrunSecDetaySatinAlma",
      "CategoryName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "kategorsecidetaysatinalma_265841_value",
          "productAtt01Desc"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UrunSecDetaySatinAlma",
      "TotalQty1",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TotalQty1 ?? this.props.screenInputs.totalqty1,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UrunSecDetaySatinAlma",
      "TotalAmount",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TotalAmount ??
          this.props.screenInputs.totalamount,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UrunSecDetaySatinAlma",
      "VendorCode",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UrunSecDetaySatinAlma",
      "dateFilter",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "KategorSeciDetaySatinAlma",
      "UrunSecDetaySatinAlma",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KategorSeciDetaySatinAlmaPageInit();
    }
  }
}
